import { render, staticRenderFns } from "./StartingPage.vue?vue&type=template&id=07f4c08d&scoped=true&"
import script from "./StartingPage.vue?vue&type=script&lang=js&"
export * from "./StartingPage.vue?vue&type=script&lang=js&"
import style0 from "./StartingPage.vue?vue&type=style&index=0&id=07f4c08d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4c08d",
  null
  
)

export default component.exports